import { useCallback, useEffect, useState } from 'react';
import { findClients } from '../services/clientService';

export function useClientsSearch() {
  const [clients, setClients] = useState([]);
  const [filters, setFilters] = useState({ name: '', surname: '', phone: '', email: '' });
  const [loading, setLoading] = useState(false);

  const searchClients = useCallback(async (nextFilters = {}) => {
    setLoading(true);

    try {
      const data = await findClients(nextFilters);
      setClients(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    searchClients();
  }, [searchClients]);

  return {
    clients,
    filters,
    loading,
    setFilters,
    searchClients,
  };
}
